module.exports = __webpack_public_path__ + "static/media/C3.4e0e6353.png";